import { CreateLifeCycleReduxState, LifeCycleReducerDispatch, LifeCycleReduxTypes } from "./types"

const CREATE_LIFE_CYCLE_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateLifeCycleReducer = (state: CreateLifeCycleReduxState = CREATE_LIFE_CYCLE_INIT_STATE, action: LifeCycleReducerDispatch) => {
    switch (action.type) {
        case LifeCycleReduxTypes.LIFE_CYCLE_REPORT: {
            return {
                ...state,
                loading: true
            }
        }
        case LifeCycleReduxTypes.LIFE_CYCLE_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case LifeCycleReduxTypes.LIFE_CYCLE_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            }
        }
        case LifeCycleReduxTypes.RESET_LIFE_CYCLE:{
            return {
                ...state,
                data:{},
                loading : false,
                error:null
            }
        }
        default:
            return { ...state }
    }
}
export { CreateLifeCycleReducer }